// Bootstrap anti-ciclo de imports — EXECUTA ANTES DE TUDO.
//
// Colocado em arquivo separado e importado como a PRIMEIRA linha de
// `src/index.jsx` (antes de qualquer outro import que puxe o grafo). Desta
// forma, as referências abaixo já estão no `globalThis` antes mesmo de
// `useAuth.js` carregar seus interceptors de axios na carga do módulo —
// eliminando 100% o erro clássico de `Cannot read properties of null
// (reading 'useContext')` que acontecia por ordem estranha de imports no
// dev server do Vite.
//
// NÃO TENTE substituir por import inline no `index.jsx`: o hoisting do ES
// module faz todos os imports do arquivo serem resolvidos na mesma hora,
// então uma atribuição no corpo do `index.jsx` ainda roda DEMAIS tarde.
// Importar um arquivo separado FIRST garante a ordem.
import * as React from "react";
import * as ReactRouterDOM from "react-router-dom";

globalThis.__CRM_REACT__ = React;
globalThis.__CRM_REACT_ROUTER_DOM__ = ReactRouterDOM;
